/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'depot': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<g transform="translate(1 1)" _fill="none" fill-rule="evenodd"><circle pid="0" _stroke="#234357" stroke-width="2" cx="9" cy="9" r="9"/><text font-family="ProximaNova-Extrabld, Proxima Nova" font-size="13" font-weight="600" letter-spacing=".325" _fill="#008AFF"><tspan x="5" y="13">D</tspan></text></g>'
  }
})
